import SportEventType from './enums/SportEventType'
import { LanguageService } from '../../LanguageService'
import { Browser } from '../Browser'
import store from '../../../index';
import { setSeoSettingsParams, getSeoMatchRules } from '../../../actions/seo/SeoSettingsAction';
import DeviceTypeEnum from '../../../constants/DeviceTypeEnum';
import config from '../../../constants/Configs';
import DateHelper from '../DateHelper';
import SeoHelper from '../../../components/base/SeoHelper';

/**
 * @namespace SportRoutingHelper 
 */
const SportRoutingHelper = {
    queryStringPrefix: 'flt-',
    queryStringPostfix: '-sub',
    /**
     * Url change handler
     * @param {object } event Camel case string
     * @param {string} lang Selected language
     */
    urlChangeHandler: (e, lang, product = 'sport') => {
        const event = e?.data || e;
        const type = event && event?.type;

        if (type === SportEventType.RouteChange) {
            SportRoutingHelper.dispatchSeoEvent(event?.message?.additionalData);
            lang = lang ? lang : LanguageService.getSelectedLanguage();
            let newURL = `/${lang}/${product}`;
            const path = event?.message?.path || event?.message?.pathname;
            const qs = event?.message?.qs;
            const hashData = event?.message?.hashData;


            let queryString;

            queryString = queryString ? `${path?.endsWith('/') ? '' : '/'}${SportRoutingHelper.queryStringPrefix}${queryString}${SportRoutingHelper.queryStringPostfix}` : '';

            if (hashData) {
                queryString = `${path?.endsWith('/') ? '' : '/'}${SportRoutingHelper.queryStringPrefix}${hashData}${SportRoutingHelper.queryStringPostfix}`;
            } else {
                queryString = qs ? new URLSearchParams(qs).toString() : "";
                queryString = queryString ? `${path?.endsWith('/') ? '' : '/'}${SportRoutingHelper.queryStringPrefix}${queryString}${SportRoutingHelper.queryStringPostfix}` : '';

            }

            if (path == "/event-details") {
                let eventName = event?.message?.additionalData?.eventName;
                eventName = eventName && SportRoutingHelper.makeSeoFriendly(eventName);
                newURL = `${newURL}${path}/${qs.champ ? qs.champ : 0}-${qs.event}-${qs.country ? qs.country : 0}-${qs.sport ? qs.sport : 0}-${qs.supertip ? qs.supertip : 0}-${qs.live ? qs.live : 0}-${eventName ? eventName : ''}`
            } else if (path == "/team-details") {
                let eventData = event?.message?.additionalData;
                let competitorName = eventData?.competitorName && SportRoutingHelper.makeSeoFriendly(eventData?.competitorName);
                let sportName = eventData?.sportName && eventData?.sportName && SportRoutingHelper.makeSeoFriendly(eventData?.sportName);
                newURL = `${newURL}${path}/${qs.eventId ? qs.eventId : 0}-${qs.competitorId ? qs.competitorId : 0}-${sportName ? sportName : ''}-${competitorName ? competitorName : ''}`
            } else if (path == "/pre-match" || path == "/live") {
                let eventData = event?.message?.additionalData;
                let chapmName = eventData?.chapmName && eventData?.chapmName[0] && SportRoutingHelper.makeSeoFriendly(eventData?.chapmName[0]);
                let sportName = eventData?.sportName && eventData?.sportName[0] && SportRoutingHelper.makeSeoFriendly(eventData?.sportName[0]);
                let champTitle = `${sportName ? sportName : ''}${chapmName ? `-${chapmName}` : ''}`;
                newURL = `${newURL}${path}${champTitle ? `/${champTitle}` : ''}${queryString}`;
            } else {
                newURL = `${newURL}${path ? path : ""}${queryString}`;
            }

            //window.history.replaceState(null, null, newURL);
            store.getState().settings?.seoRulesEnabled && store.dispatch(getSeoMatchRules(window.location.pathname));
            return newURL;
        } else if (type === SportEventType.EventDetails) {
            SportRoutingHelper.dispatchSeoEvent(event?.message?.additionalData);
        }
    },
    /**
     * Dispatchwa event with sport event specefic data
     * @param {object } data Data sent by sport app
     */
    dispatchSeoEvent: (data) => {
        if (data) {
            const lang = LanguageService.getSelectedLanguage();
            const { eventDate, eventName, eventCurrentName, sportName, sportCurrentName, team1, team1CurrentName, team2, team2CurrentName, tournamentName, tournamentCurrentName, champName, coutryName, competitorName, competitorCurrentName } = data;
           
            // SEO RULE DATE FORMAT TYPE  BLD-24748
            let dateFormatString = null
            let seoRuleContent = store.getState().seo?.rules?.content || {};
            if (Object.keys(seoRuleContent).length > 0) {
                const dateFormatType = seoRuleContent[Object.keys(seoRuleContent)[0]]?.dateFormatType;
                dateFormatString = SeoHelper.DateTypeEnum[`${dateFormatType}`] || null;
            }
            DateHelper.format(eventDate, dateFormatString, lang).then((localDate) => {

                const sportData = {
                    sportName: sportCurrentName || (Array.isArray(sportName) ? sportName[0] : sportName),
                    sportEventDate: localDate,
                    sportEventName: eventCurrentName || eventName,
                    sportTeam1: team1CurrentName || team1,
                    sportTeam2: team2CurrentName || team2,
                    sportTournamentName: tournamentCurrentName || tournamentName,
                    champName: Array.isArray(champName) ? champName[0] : champName,
                    coutryName: Array.isArray(coutryName) ? coutryName[0] : coutryName,
                    competitorName: competitorCurrentName || competitorName
                };
                store.dispatch(setSeoSettingsParams(lang, sportData));
            })

        }
    },

    /** 
    * Url change handler
    * @param {string} str String which should be alerted
    */
    makeSeoFriendly: (str) => {
        if (typeof str !== 'string') return "";
        let newString = [];
        for (let index = 0; index < str.length; index++) {
            const element = str[index];
            const notAllowedSymbolsRegex = /^\.| - | |%|-|\/|\\|'|\+|`$/g;
            const isAllowedSymbol = !element.match(notAllowedSymbolsRegex);
            //Trim all not allowed sybols from the begining of the string
            if (newString.length == 0 && isAllowedSymbol) {
                newString.push(element?.toLowerCase());
                continue;
            }
            if (newString.length > 0) {
                if ((!isAllowedSymbol) && newString[newString.length - 1] !== '-') {
                    newString.push('-');
                } else if ((!isAllowedSymbol) && newString[newString.length - 1] === '-') {
                    continue;
                } else if (!isAllowedSymbol && index + 1 < str.length && (str[index + 1] !== ' ' || str[index] !== '.' || str[index] !== '-')) {
                    newString.push('-');
                } else {
                    newString.push(element?.toLowerCase());
                }
            }
        }

        if (newString[newString.length - 1] === '-') {
            newString = newString.slice(0, -1);
        }

        return newString.join('');
    },
    /**
     * Convert string to camel case string
     * @param {string } page Sport page name
     * @param {string } targetId Sport target id
     * @param {string } viewType Sport view type
     */
    openPage: (page, targetId, viewType) => {
        try {
            let message = SportRoutingHelper.generateRouteObject(page, targetId);
            const sportWindow = window.sportMobileApp || window[viewType] || window?.SportFrame || window.esportApp;
            const route = { type: SportEventType.RouteChange, message };
            if (sportWindow?.starter) {
                sportWindow?.starter?.dispatchEvent('sportAppEventListener', route);
            } else if (sportWindow?.setSportAppRoute) {
                sportWindow.setSportAppRoute(route)
            }
        } catch {

        }
    },
    /**
     * Generate routing object for sport
     * @param {string } page Sport page name
     * @param {string } targetId Sport target id
     * @return {object} Sport/Esport routing object
     */
    generateRouteObject: (page, targetId) => {
        let qs;
        const EVENT_DETAILS_PAGE = "event-details";
        const TEAM_DETAILS_PAGE = "team-details";
        const PRE_MATCH_PAGE = "pre-match";
        const LIVE_PAGE = "live";
        let hashData;

        if (page?.search === 'popup=MyBets' || page === "/BetHistory" || page === "BetsHistory") {
            if (Browser.getDeviceType() === DeviceTypeEnum.Mobile) {
                return { path: 'bet-history' }
            } else {
                return { path: '/bet-history' }
            }
        }

        if (page && page?.split('/').length > 1) {
            page = page.split('/')[1];
        }

        page = page?.startsWith('/') ? page.substring(1) : page;

        if (page == EVENT_DETAILS_PAGE && targetId) {
            const params = targetId.split('-');
            qs = { 'champ': params[0], 'event': params[1], 'country': params[2], 'sport': params[3], 'supertip': params[4], 'live': params[5] };
        } else if (page == TEAM_DETAILS_PAGE) {
            const params = targetId.split('-');
            qs = { 'eventId': params[0], 'competitorId': params[1] };
        } else {
            hashData = SportRoutingHelper.getQueryString(window.location.pathname);
            //const q = SportRoutingHelper.getQueryString(window.location.pathname);
            //qs = Browser.getObjectFromQueryString(q);
        }
        const ignoreTarget = [EVENT_DETAILS_PAGE, PRE_MATCH_PAGE, LIVE_PAGE, TEAM_DETAILS_PAGE].includes(page) || !targetId;
        const path = `/${page ? page : ''}${`${ignoreTarget ? '' : `/${targetId}`}`}`;



        return { path, qs, hashData };
    },

    /**
    * Navigate to sport event
    * @param {object} data Sport event data
    * @param {object} history React router history
    */
    navigateToEvent: (data, history) => {
        const eventData = data?.data;
        const { partnerId } = store.getState().settings;
        const isNewRoutingModeEnabled = config?.SPORT_NEW_ROUTING?.indexOf(partnerId) >= 0 ? true : false;
        const isNewRoutingEnabledForAllPartners = config?.SPORT_NEW_ROUTING_ENABLED;
        if (data && data.type == 'navigateToEvent') {
            //Temparary
            if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
                const eventName = SportRoutingHelper.makeSeoFriendly(eventData.Name);
                history.replace(`/sport/event-details/${eventData.champ ? eventData.champ : 0}-${eventData.Id}-${eventData.country ? eventData.country : 0}-${eventData.sport ? eventData.sport : 0}-${eventData.supertip ? eventData.supertip : 0}-${eventData.live ? eventData.live : 0}-${eventName ? eventName : ''}`);
            } else {
                history.replace(`/sport/UpcomingDetails/${eventData.Id}`);
            }
        } else if (data && data.type == 'navigateToChampionship') {
            if (isNewRoutingEnabledForAllPartners || isNewRoutingModeEnabled) {
                history.replace(`/sport/pre-match/${eventData?.sportName ? eventData.sportName : ''}-${SportRoutingHelper.makeSeoFriendly(eventData.Name)}?${encodeURI(`q={${eventData.sport}:{${eventData.country}:[${eventData.Id}]}}`)}`);
            } else {
                history.replace(`/sport/Upcoming/${eventData.Id}`);
            }
        }
    },
    /**
     * Get Sport/Esport route url
     * @param {string } product Product name sport or esport 
     * @return {string} Returns url part presented after /sport or /esport 
     */
    getPageUrl: (product, location = window?.location?.href) => {
        let page = "";
        let splitedUrl = location?.split(`/${product}`);
        if (splitedUrl.length === 2) {
            page = splitedUrl[1];
        } else if (splitedUrl.length > 2) {
            page = `/${location?.split(`/${product}/`)[1]}`
        }
        return page;
    },
    /**
     * Get Sport/Esport route url
     * @param {string } url - Url
     * @return {string} - returns query string from url
     */
    getQueryString: (url) => {
        const prefix = SportRoutingHelper.queryStringPrefix;
        const postfix = SportRoutingHelper.queryStringPostfix;
        // regular expression to match querystring snippet
        const regex = new RegExp(`${prefix}[\\s\\S]*${postfix}`, 'g');
        const matches = url?.match(regex);
        let result = matches?.length ? matches[matches.length - 1] : null;
        return result ? result.substring(result.indexOf(prefix) + prefix.length, result.indexOf(postfix)) : result;

    }
}
export default SportRoutingHelper;
